/* eslint-disable no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });

  register(
    '/service-worker.js',
    {
      updated(registration: any) {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      },
      error(error: any) {
        console.error('Error during service worker registration:', error);
      },
    },
  );
}
